import classNames from "classnames";

import { Typography } from "@/components/Typography";
import { PreviewCloudinaryImage } from "@/features/previews/shared";
import type { BusinessHeaderProps } from "../types";

export const BusinessHeader = ({ data, isInitialPreview }: BusinessHeaderProps) => {
  const { companyName, logoUrl, title } = data;

  return (
    <>
      {companyName && (
        <div className="business-template__company-name">
          <Typography
            Tag="p"
            classname="u-semibold"
          >
            {companyName}
          </Typography>
        </div>
      )}

      <div className="business-template__header">
        {logoUrl && (
          <div className="business-template__logo-container">
            <PreviewCloudinaryImage
              src={logoUrl}
              alt={companyName || title || "Business logo"}
              className="business-template__logo"
              placeholderClass="business-template__logo"
              variant="hero"
              isInitPreview={isInitialPreview}
            />
          </div>
        )}

        {title && (
          <div
            className={classNames("business-template__title", {
              "business-template__title--with-logo": logoUrl,
            })}
          >
            <Typography
              Tag="p"
              size="l"
              classname="u-semibold u-spacing-4"
            >
              {title}
            </Typography>
          </div>
        )}
      </div>
    </>
  );
};
